import { render, staticRenderFns } from "./TabSwitcher.vue?vue&type=template&id=0194f405&scoped=true&"
import script from "./TabSwitcher.vue?vue&type=script&lang=ts&"
export * from "./TabSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./TabSwitcher.vue?vue&type=style&index=0&id=0194f405&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194f405",
  null
  
)

export default component.exports